<template>
  <div>
    <el-dialog
      title="Crear Reclamación"
      :visible.sync="showDialogVisible"
      width="35%"
      v-loading.fullscreen.lock="fullscreenLoading"
      :before-close="handleClose"
      :close-on-click-modal="true"
      close-on-press-escape
      show-close
    >
      <el-form
        :model="ComplaintForm"
        :rules="rules"
        ref="ComplaintForm"
        label-width="120px"
      >
        <el-form-item label="Descripción" prop="desc">
          <el-input
            type="textarea"
            autosize
            placeholder="Por favor Digite su Reclamacion aqui"
            v-model="ComplaintForm.desc"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          size="mini"
          @click="submitForm('ComplaintForm')"
          >Crear</el-button
        >
        <el-button
          type="warning"
          size="mini"
          @click="resetForm('ComplaintForm')"
          >Limpiar Texto</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
//import axios from "axios";

export default {
  name: "DialogNewComplaintForm",
  data() {
    return {
      showDialogVisible: false,
      fullscreenLoading: false,
      ClientCode: String,
      CompanyId: String,
      Token: "",
      CodigoReclamacion: "",
      ComplaintForm: {
        desc: ""
      },
      rules: {
        desc: [
          {
            required: true,
            message: "Favor colocar la descripcion de la reclamación",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.getToken();
  },

  methods: {
    show(row) {
      this.ClientCode = row.ClientCode;
      this.CompanyId = row.CompanyId;
      this.showDialogVisible = true;
    },
    getToken() {
      let self = this;
      var jsonResponse = {};
      const user = "agreyes@magycorp.com";
      const pass = "123456";
      const grant_type = "password";
      const xhttp = new XMLHttpRequest();
      xhttp.open("POST", "https://apicloud.magycorp.com:48096/token");
      xhttp.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );

      xhttp.onload = function () {
        jsonResponse = JSON.parse(xhttp.responseText);
        let { access_token } = jsonResponse;
        self.Token = access_token;
      };
      xhttp.send(`username=${user}&password=${pass}&grant_type=${grant_type}`);

      // const config = {
      //   headers: {
      //     // withCredentials: true,
      //     "Access-Control-Allow-Origin": "*",
      //     "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
      //     "Access-Control-Allow-Headers":
      //       "Content-Type, Authorization, X-Requested-With"

      //     // "Access-Control-Allow-Credentials": true,
      //     // "Access-Control-Allow-Origin": "*",
      //     // "Access-Control-Allow-Methods": "POST,GET,PUT,DELETE",
      //     // "Access-Control-Allow-Headers": "Authorization, Lang"
      //   }
      // };

      //let seft = this;

      //   axios
      //     .post("http://mgsrvweb.rd.magycorp.com:8586/token", body)
      //     .then((resp) => {
      //       console.log("Token: ", resp);
      //     })
      //     .catch((error) => {
      //       console.error("Error: ", error);
      //     });
      //   //.finally(() => {});
    },
    submitForm(formName) {
      let self = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let token = self.Token;
          this.SendComplaint(token);
          this.$message({
            showClose: true,
            message: "Su reclamacion ha sido subministrada exitosamente",
            type: "success"
          });
        } else {
          console.error("Error al suministrar la reclamacion");
          this.$message({
            showClose: true,
            message: "Error al suministrar la reclamacion",
            type: "error"
          });
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    SendComplaint(token) {
      /*

      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };

      console.log("config: ", config);
      */

      const bodyParameters = {
        Cliente: this.ClientCode,
        Tipo: "Reclamación",
        Motivo: "Soporte Ténico",
        Detalles: this.ComplaintForm.desc,
        Status: false,
        Company: this.CompanyId
      };

      // let Cliente = this.ClientCode;
      // let Tipo = "Reclamación";
      // let Motivo = "Soporte Ténico";
      // let Detalles = this.ComplaintForm.desc;
      // let Status = false;
      // let Company = this.CompanyId;

      //console.log("bodyParameters: ", bodyParameters);

      const xhttp = new XMLHttpRequest();
      xhttp.open(
        "POST",
        "https://apicloud.magycorp.com:48096/api/Quejas/NewReclamacion"
      );
      xhttp.setRequestHeader("Authorization", `Bearer ${token}`);
      xhttp.setRequestHeader("Content-type", "application/json");
      xhttp.onload = function () {
        self.CodigoReclamacion = xhttp.responseText;
      };
      xhttp.send(JSON.stringify(bodyParameters));
      // `Cliente=${Cliente}&Tipo=${Tipo}&Motivo=${Motivo}&Detalles=${Detalles}&Status=${Status}&Company=${Company}`
      // );
      /*
      axios
        .post(
          "http://mgsrvweb.rd.magycorp.com:8586/api/Quejas/NewReclamacion",
          bodyParameters,
          config
        )
        .then((resp) => {
          console.log("Respuesta de la Queja: ", resp);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {});
      */
    },
    handleClose(done) {
      this.$refs["ComplaintForm"].resetFields();
      done();
    }
  }
};
</script>

<style scoped></style>
